export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20soft%20pastel%20fashion%20editorial%20flat%20lay%20with%20elegant%20fabric%20textures%20neutral%20cream%20beige%20warm%20white%20background%2C%20scattered%20minimalist%20fashion%20accessories%20arranged%20in%20gentle%20organic%20composition%2C%20dreamy%20soft%20natural%20window%20light%2C%20high%20key%20editorial%20catalog%20photography%2C%20calm%20serene%20atmosphere%2C%20no%20harsh%20shadows%2C%20elegant%20aesthetic&width=1920&height=1080&seq=hero-bg-v4-2026&orientation=landscape"
          alt="itaobuy.hair lifestyle products"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full px-6 md:px-10 flex flex-col items-center text-center pt-20">
        <span className="inline-block px-5 py-2 rounded-full border border-white/30 text-white text-[12px] font-medium tracking-wide mb-8 backdrop-blur-sm">
          itaobuyspreadsheet guide 2026
        </span>

        <h1 className="text-[48px] md:text-[72px] leading-[1.05] font-heading text-white mb-7 max-w-[800px]">
          Discover<br />
          <span className="italic">itaobuyspreadsheet</span>
        </h1>

        <p className="text-[15px] md:text-[16px] text-white/80 font-light max-w-[560px] leading-relaxed mb-10">
          A structured spreadsheet system that helps you compare products, track listings,
          and make smarter purchasing decisions in seconds.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-[14px] font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            itaobuy sheet
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
          <a
            href="#categories"
            className="px-8 py-3.5 rounded-full border border-white/40 text-white text-[14px] font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Categories
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a href="#categories" className="flex flex-col items-center gap-2 text-white/50 hover:text-white/80 transition-colors cursor-pointer">
          <span className="text-[10px] uppercase tracking-widest">Scroll</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}